/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { analyticsSignalDefinition } from "../funcs/analyticsSignalDefinition.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { AnalyticsSignalDefinition } from "../models/components/analyticssignaldefinition.js";
import {
  AnalyticsSignalDefinitionRequest,
  AnalyticsSignalDefinitionSecurity,
} from "../models/operations/analyticssignaldefinition.js";
import { unwrapAsync } from "../types/fp.js";
export type AnalyticsSignalDefinitionQueryData = AnalyticsSignalDefinition;

export function prefetchAnalyticsSignalDefinition(
  queryClient: QueryClient,
  client$: GramCore,
  request: AnalyticsSignalDefinitionRequest,
  security?: AnalyticsSignalDefinitionSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAnalyticsSignalDefinitionQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAnalyticsSignalDefinitionQuery(
  client$: GramCore,
  request: AnalyticsSignalDefinitionRequest,
  security?: AnalyticsSignalDefinitionSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<AnalyticsSignalDefinitionQueryData>;
} {
  return {
    queryKey: queryKeyAnalyticsSignalDefinition({
      sensorId: request.sensorId,
      definitionHash: request.definitionHash,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function analyticsSignalDefinitionQueryFn(
      ctx,
    ): Promise<AnalyticsSignalDefinitionQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(analyticsSignalDefinition(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAnalyticsSignalDefinition(
  parameters: {
    sensorId: string;
    definitionHash: string;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "analytics", "signalDefinition", parameters];
}
